export default __webpack_public_path__ + "static/media/appleMaps.cb9c0c1e.svg";